import React from "react";
import { compose, withState, withHandlers, lifecycle } from "recompose";
import { withPromise } from "react-promisify";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { fetchSlots, fetchAvailableDays } from "modules/booking/endpoints";
import Date from "./Date";
import TimeSlot from "./TimeSlot";

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default compose(
  withRouter,
  withState("isFetching", "setFetching", false),
  withState("slots", "setSlots", null),
  withPromise("days", fetchAvailableDays),
  withHandlers({
    onDateChange: p => async date => {
      p.setFetching(true);
      const slots = await fetchSlots(
        p.match.params.id,
        date.format("YYYY-MM-DD")
      );
      p.setSlots(
        slots.results.map(s => ({
          id: s.id,
          time: s.time_start
        }))
      );
      p.setFetching(false);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.days.fetch(this.props.match.params.id);
    }
  })
)(
  ({ isFetching, slots, days, onBookSlot, onDateChange, onSlotChange }) =>
    !days.lastUpdated || days.isFetching ? (
      <div className="tc">Loading...</div>
    ) : (
      <Container>
        <Card>
          <Date availableDays={days.data} onDateChange={onDateChange} />
          {isFetching ? (
            <SpinnerWrap>Loading...</SpinnerWrap>
          ) : (
            slots && (
              <TimeSlot
                slots={slots}
                onBookSlot={onBookSlot}
                onSlotChange={onSlotChange}
              />
            )
          )}
        </Card>
      </Container>
    )
);

const Container = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding: 4rem 0 0 0;
  @media (max-width: 680px) {
    margin: unset;
    padding: 2rem 0;
  }
`;

const Card = styled.div`
  background-color: #fff;
  padding: 1rem 4rem;
  @media (max-width: 680px) {
    background-color: #f9f7f2;
    padding: 0;
  }
`;

const SpinnerWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem;
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/ChooseTime/components/ChooseDate/index.js